<template>
  <Transition name="feedback-popup">
    <FeedbackPopup expand v-if="store.isFeedbackOpen" @close="handleClosePopup">
      <template #title>Message our team</template>
      <template #content>
        <StageDefault v-if="stage === Stages.DEFAULT" @close="handleClosePopup" @go-to-stage="handleGoToStage" />
        <StageChangeSomething v-if="stage === Stages.CHANGE_SOMETHING" @go-to-stage="handleGoToStage" />
        <StageHaveQuestions v-if="stage === Stages.HAVE_QUESTIONS" @go-to-stage="handleGoToStage" />
        <StageChangeWording v-if="stage === Stages.CHANGE_WORDING_OR_DESCRIPTIONS" @go-to-stage="handleGoToStage" />
        <StageAskSomethingElse v-if="stage === Stages.ASK_SOMETHING_ELSE" @go-to-stage="handleGoToStage" />
      </template>
    </FeedbackPopup>
  </Transition>
</template>

<script setup lang="ts">
import FeedbackPopup from '@/components/Theme2/FeedbackPopup.vue'
import { ref } from 'vue'
import { usePublishSetupStore } from '@/stores/publishSetup'
import { Selections, Stages } from './types'
import StageDefault from './StageDefault.vue'
import StageChangeSomething from './StageChangeSomething.vue'
import StageHaveQuestions from './StageHaveQuestions.vue'
import StageChangeWording from './StageChangeWording.vue'
import StageAskSomethingElse from './StageAskSomethingElse.vue'

const store = usePublishSetupStore()

const stage = ref<Stages>(Stages.DEFAULT)
const currentSelection = ref<Selections | null>(null)

const handleGoToStage = (newStage: Stages) => {
  stage.value = newStage
}

const handleClosePopup = () => {
  currentSelection.value = null
  stage.value = Stages.DEFAULT
  store.setIsFeedbackOpen(false)
}
</script>

<style lang="scss" scoped>
:deep(.feedback-content) {
  @include flex-column($spacing-4);
  align-items: center;

  .feedback-content__title {
    text-align: left;
    width: 100%;
  }

  .feedback-content__cancel {
    color: $brand-tertiary;
    cursor: pointer;
  }

  .btn.color.green {
    border: 0px;

    &.invert {
      color: $black;
    }
    color: $white;
  }

  .feedback-content__textarea {
    max-width: calc(100% - 2 * $spacing-6);
    min-width: calc(100% - 2 * $spacing-6);
    height: 100px;
    padding: $spacing-3 $spacing-5;
    border-radius: $spacing-1;
    border: 1px solid $gray-lighter;
  }

  .btn {
    width: calc(100% - $spacing-5 * 2);
  }
}

.feedback-popup-leave-active {
  animation: slideDownFadeOut 0.5s cubic-bezier(0, 0, 0.6, 1);
}

.feedback-popup-enter-active {
  animation: slideUpFadeIn 0.5s cubic-bezier(0, 0, 0.6, 1);
}
</style>
